
import React from 'react';

import { EPOD_ERROR_MESSAGE } from '@/utils/constants';
import { getTrans } from '@/utils/tools';
import { Image as UIImage } from '@shopee/chatbot-ui';
import { ImageProps } from '@shopee/chatbot-ui/lib/components/Image';

const Image = (props: ImageProps) => {
  const stylesProperty = {
    minHeight: '32vw',
    minWidth: '32vw',
    maxHeight: '40vw',
    maxWidth: '40vw',
    margin: 4,
  };

  return (
    <UIImage
      {...props}
      {...stylesProperty}
      preview={true}
      fallbackText={getTrans(EPOD_ERROR_MESSAGE) || 'epod load Error'}
    />
  );
};

export default Image;
